import Platform from './platform';
import $ from 'webpack-zepto';
import { cookie } from 'cookie_js';
const instId = window.getParameterByName('instId');
const toPage = window.getParameterByName('toPage');
const appid = window.getParameterByName('appid') || window.getParameterByName('appId');
const openId = window.getParameterByName('openid');
const needLogin = window.getParameterByName('needLogin');
if (instId && appid && (location.hash.indexOf('online/order/confirm') === -1)&& (location.hash.indexOf('voucher_detail') === -1)) {
  const key = 'weixin_instId_' + appid;
  const cKey = 'c_weixin_instId_' + appid;
  Cache.set(key, instId);
  Cache.set(key, instId);
  window.LS.setItem(key, instId);
  window.LS.setItem(cKey, instId);
}
if (toPage) {
  window.Cache.set('toPage', toPage);
  window.Cache.set('c_toPage', toPage);
}

if (appid) {
  window.LS.setItem('appid', appid);
  window.LS.setItem('c_appid', appid);
}

if (appid && openId) {
  const key = 'weixin_openId_' + appid;
  const cKey = 'c_weixin_openId_' + appid;
  Cache.set(key, openId);
  Cache.set(key, openId);
  window.LS.setItem(key, openId);
  window.LS.setItem(cKey, openId);
}

if (needLogin) {
  window.Cache.set('needLogin', needLogin);
  window.Cache.set('c_needLogin', needLogin);
}


class User {
  uid() {
    const key = 'weixin_uid_' + this.appId();
    let uid = window.Cache.get(key) || window.LS.getItem(key);
    if (uid) {
      uid = uid.replace(/"/g, '').replace(/'/g, '');
    }
    return uid;
  }

  setUserConfig(config) {
    const cKey = 'c_weixin_config_' + this.appId();
    window.LS.setItem(cKey, config);
  }

  getUserConfig() {
    const cKey = 'c_weixin_config_' + this.appId();
    return window.LS.getItem(cKey);
  }

  setUid(uid) {
    const key = 'weixin_uid_' + this.appId();
    const cKey = 'c_weixin_uid_' + this.appId();
    window.LS.setItem(key, uid);
    window.LS.setItem(cKey, uid);
    window.Cache.set(key, uid);

  }

  token() {
    const key = 'weixin_token_' + this.appId();
    return window.Cache.get(key) || window.LS.getItem(key);
  }

  setToken(token) {
    const key = 'weixin_token_' + this.appId();
    const cKey = 'c_weixin_token_' + this.appId();
    window.LS.setItem(key, token);
    window.LS.setItem(cKey, token);
    window.Cache.set(key, token);
  }
  phone() {
    const key = 'weixin_phone';
    return window.LS.getItem(key);
  }

  setPhone(phone) {
    const key = 'weixin_phone'
    window.LS.setItem(key, phone);
  }


  openId() {
    const key = 'weixin_openId_' + this.appId();
    return Cache.get(key) || window.LS.getItem(key);
  }

  setOpenId(id) {
    const key = 'weixin_openId_' + this.appId();
    const cKey = 'c_weixin_openId_' + this.appId();
    Cache.set(key, id);
    Cache.set(key, id);
    window.LS.setItem(key, id);
    window.LS.setItem(cKey, id);
  }

  appId() {
    return window.getParameterByName('appid') || Cache.get('appid') || window.LS.getItem('appid');
  }

  setInstId(id) {
    const key = 'weixin_instId_' + this.appId();
    const cKey = 'c_weixin_instId_' + this.appId();
    Cache.set(key, id);
    Cache.set(key, id);
    window.LS.setItem(key, id);
    window.LS.setItem(cKey, id);
  }

  instId() {
    return window.getParameterByName('instId') || Cache.get('instId') || window.LS.getItem('instId');
  }

  //保存用户信息
  setUserInfo(userInfo) {
    const data = JSON.stringify(userInfo);
    window.LS.setItem('weixin_user_info', data);
  }

  getUserInfo() {
    const data = window.LS.getItem('weixin_user_info');
    return data ? JSON.parse(data) : {};
  }

  setUserAvatar(avatarInfo) {
    const data = JSON.stringify(avatarInfo);
    window.LS.setItem('weixin_avatar', data);
  }

  getUserAvatar() {
    const data = window.LS.getItem('weixin_avatar');
    return data ? JSON.parse(data) : {};
  }



  //保存用户信息
  setInstList(instList) {
    const data = JSON.stringify(instList);
    window.LS.setItem('weixin_inst_list', data);
  }

  getInstList() {
    const data = window.LS.getItem('weixin_inst_list');
    return data ? JSON.parse(data) : [];
  }

  //判定用户是否登录过
  logined() {
    return !!(this.token());
  }

  currentInstId() {
    return window.LS.getItem('instId');
  }

  setCurrentInst(currentInst) {
    window.LS.setObj('instInfo', currentInst);
  }

  currentInst() {
    return window.LS.getObj('instInfo');
  }

  setCurrentInstOfBind(currentInstOfBind) {
    window.LS.setObj(`currentInstOfBind_${this.uid()}_${this.appId()}`, currentInstOfBind);
  }

  currentInstOfBind() {
    return window.LS.getObj(`currentInstOfBind_${this.uid()}_${this.appId()}`);
  }

  setBindStudentList(bindStudentList) {
    window.LS.setObj('bindStudentList', bindStudentList);
  }

  bindStudentList() {
    return window.LS.getObj('bindStudentList');
  }

  setCurrentWheat(currentWheat) {
    window.LS.setObj('currentWheat', currentWheat);
  }
  currentWheat() {
    return window.LS.getObj('currentWheat') || {};
  }
  currentWheatNum() {
    const { count } = this.currentWheat();
    return count <= 0 ? 0 : count;
  }
  currentWheatName() {
    const { name = '小麦粒' } = this.currentWheat() || {};
    return name;
  }

  loginInsure() {
    localStorage.clear();
    const appid = window.CONFIG.InsureAppId();
    let url = location.origin + location.pathname + location.hash;
    console.log(8888, url)
    const reloadUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
      url,
    )}&response_type=code&scope=snsapi_base#wechat_redirect`;
    location.replace(reloadUrl);
  }

  loginIn() {
    if (!APPID) {
      return
    }
    const appId = appid || localStorage.getItem('appid');
    let instId = this.instId() || '';
    if (appId === APPID) {
      instId = ''
    }
    if (appId) {
      let redirectUri = location.origin + location.pathname;
      redirectUri += '?' + $.param({
        appid: appId,
        instId: instId,
      });

      redirectUri += location.hash
      redirectUri = encodeURIComponent(redirectUri);
      let redirect = "";
      localStorage.clear();
      window.Cache.clear();
      window.LS.clearCookie()
      if (appId === APPID) { // 标准版
        redirect = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=state#wechat_redirect`;
        window.location.href = redirect;
      } else {
        redirect = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&component_appid=${COMPOMENTID}&response_type=code&scope=snsapi_base&state=state#wechat_redirect`;
        window.location.href = redirect;
      }
    } else {
      if (Platform.isWeiXin()) {
        document.body.innerHTML =
          `<div style="display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;">
              <div>账号未登录</div>
              <div>请在公众号下方入口进行登录</div>
          </div>`;
        setTimeout(() => {
          WeixinJSBridge.invoke('closeWindow');
        }, 1000)
      } else {
        document.body.innerHTML =
          `<div style="display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;">
              <div>请复制链接到微信中打开</div>
          </div>`;
      }

    }
  }
  //登出清楚用户保存的数据
  loginOut() {
    const uidKey = 'weixin_uid_' + this.appId();
    const cUidKey = 'c_weixin_uid_' + this.appId();
    window.LS.removeItem(uidKey);
    window.LS.removeItem(cUidKey);
    const tokenKey = 'weixin_token_' + this.appId();
    window.LS.removeItem(tokenKey);
    const cTokenKey = 'c_weixin_token_' + this.appId();
    window.LS.removeItem(cTokenKey);
    const openIdKey = 'weixin_openId_' + this.appId();
    window.LS.removeItem(openIdKey);
    const cOpenIdKey = 'c_weixin_openId_' + this.appId();
    window.LS.removeItem(cOpenIdKey);
    window.LS.removeItem('weixin_instInfo');
    window.LS.removeItem('inst_list');
    window.LS.removeItem('instInfo');
    window.LS.removeItem('instId');
    window.LS.removeItem('c_weixin_instInfo');
    window.LS.removeItem('c_inst_list');
    window.LS.removeItem('c_instInfo');
    window.LS.removeItem('c_instId');
    window.Cache.clear();
    cookie.empty() //清理cookie
  }
}

export default new User();



// WEBPACK FOOTER //
// ./src/core/user.js